import { AllCompDataResponse, TKV2_ORDER_ATTACHMENT_API } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import {
  GetAllCompDataError,
  GetAllCompDataVariables,
  fetchGetAllCompData,
} from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_ORDER_ATTACHMENT_API.COMP_DATA.GET;

export const useGetAllCompData = (
  variables: GetAllCompDataVariables,
  opts?: Omit<UseQueryOptions<AllCompDataResponse, GetAllCompDataError>, 'queryKey' | 'queryFn'>,
): UseQueryResult<AllCompDataResponse, GetAllCompDataError> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<AllCompDataResponse, GetAllCompDataError>({
    queryKey: queryKeyFn({
      path: '/api/v2/orders/{orderID}/attachments/compdata',
      operationId: 'getAllCompData',
      variables,
    }),
    queryFn: async () => {
      const res = await fetchGetAllCompData({ ...fetcherOptions, ...variables });
      return API_SCHEMA.RESPONSE.parse(res);
    },
    ...opts,
  });
};
